import React from "react";

// Mantém um ecrã de recuperação quando ocorre uma exceção durante o render.
// Não oculta os erros nem contorna as autorizações da API.
export default class AppErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error, info) {
    console.error("GESTOR_RENDER_ERROR", error, info?.componentStack);
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return <main role="alert" style={{minHeight:"100vh",display:"grid",placeContent:"center",padding:24,fontFamily:"system-ui,sans-serif",background:"#f8fafc",color:"#263349",textAlign:"center"}}>
      <h1 style={{fontSize:22}}>Não foi possível carregar o Gestor</h1>
      <p>Verifique a ligação à Internet e atualize a página. Se persistir, contacte o suporte.</p>
      <button type="button" style={{padding:12,background:"#1976d2",color:"#fff",border:0,borderRadius:8}}
        onClick={() => window.location.reload()}>Tentar novamente</button>
    </main>;
  }
}
